import { styled } from 'parkdepot-shared/theme'

const SubscriptionsContainer = styled('div', ({ $theme }) => ({}))

export default SubscriptionsContainer

export const SectionTitle = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphLarge,
    color: '#1F1F1F',
    margin: 0,
    fontWeight: 600,
    [$theme.mediaQuery.large]: {
        ...$theme.typography.HeadingXSmall
    }
}))

export const MonthSelectContainer = styled('div', ({ $theme }) => ({
    margin: '1.6rem 0',
    width: '100%',

    [$theme.mediaQuery.large]: {
        width: '260px'
    }
}))
